// TROIA-V3-FRONTEND/src/modules/crm/seller-dashboard/components/SellerCelebration.tsx
import React, { useCallback, useEffect, useRef } from 'react';

import { Icon } from '@/shared/icons';

import '../seller-dashboard.css';

interface SellerCelebrationProps { points: number; onDone: () => void; }

const SPARKS = Array.from({ length: 8 }, (_, i) => ({ dx: `${Math.round(Math.cos((i / 8) * Math.PI * 2) * 60)}px`, dy: `${Math.round(Math.sin((i / 8) * Math.PI * 2) * 40)}px` }));

/**
 * "Jornada concluída! +N pontos" — CSS puro; estado final visível mesmo com
 * reduzir movimento.
 *
 * O timer arma UMA vez, na montagem. `onDone` normalmente chega como arrow
 * inline do pai (`onDone={() => setCelebration(null)}`), ou seja, muda de
 * identidade a cada render — com `[onDone]` nas dependências, qualquer render
 * do dashboard (socket de captura, refetch de 30s) limpava e rearmava os
 * 3,5s, e a mensagem podia ficar na tela indefinidamente. O `ref` guarda
 * sempre a última função sem reentrar no efeito.
 */
export const SellerCelebration: React.FC<SellerCelebrationProps> = ({ points, onDone }) => {
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;
  const finish = useCallback(() => { onDoneRef.current(); }, []);
  useEffect(() => {
    const t = window.setTimeout(finish, 3500);
    return () => window.clearTimeout(t);
  }, [finish]);
  return (
    <div className="seller-celebration" role="status" aria-live="polite" data-testid="seller-celebration">
      {SPARKS.map((s, i) => <i key={i} className="seller-celebration__spark" style={{ '--dx': s.dx, '--dy': s.dy } as React.CSSProperties} />)}
      <Icon name="star" size={16} /> Jornada concluída! +{points} {points === 1 ? 'ponto' : 'pontos'}
    </div>
  );
};
SellerCelebration.displayName = 'SellerCelebration';
